enum ReportStatus {
  NEW = 'NEW',
  OPEN = 'OPEN',
  STAGNANT = 'STAGNANT',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
  NO_STATUS = 'NO_STATUS'
}

export default ReportStatus;
